<template>
    <v-navigation-drawer location="right" mobile-breakpoint="lg" style="background: #fafafa" :width="300" :model-value="$vuetify.display.lgAndUp || drawer" @update:modelValue="(value) => drawer = value">
        <div class="d-flex flex-column h-screen">
            <div @click="$router.push({ path: '/kb' })" class="my-2 text-center">
                <v-img v-if="$system.systemSettings.knowledge_base_logo_name" :src="$system.systemSettings.knowledge_base_logo_name" class="mx-auto rounded-sm w-100 mx-3" :height="50"></v-img>
                <v-img v-else src="@/assets/img/logo.svg" class="mx-auto rounded-sm w-100 mx-3" :height="50"></v-img>
            </div>
            <div class="px-2 w-100 flex-grow-1 d-flex flex-column">
                <v-list
                    mandatory
                    density="default"
                    v-model:opened="openedMenu"
                    v-model:selected="selectedMenu"
                    @update:selected="$router.push({ path: selectedMenu[0] })"
                    class="w-100"
                    selected-class="bg-secondary"
                    open-strategy="single"
                    v-if="$system.kbCategories && $system.kbCategories.length"
                >
                    <template v-for="item in $system.kbCategories">
                        <v-list-item rounded v-if="!item.children.length" :value="`/kb/categories/${item.id}`">
                            <template v-slot:prepend>
                                <v-img v-if="item.icon" :src="item.icon" width="18" height="18" class="me-5"></v-img>
                                <v-icon v-else class="me-5" size="18" icon="icon-categorykb"></v-icon>
                            </template>
                            <v-list-item-title class="text-meta">{{ item.name }}</v-list-item-title>
                        </v-list-item>
                        <v-list-group :value="item.name" v-else>
                            <template v-slot:activator="{ props }">
                                <v-list-item v-bind="props" rounded>
                                    <template v-slot:prepend>
                                        <v-img v-if="item.icon" :src="item.icon" width="18" height="18" class="me-5"></v-img>
                                        <v-icon v-else class="me-5" size="18" icon="icon-categorykb"></v-icon>
                                    </template>
                                    <v-list-item-title class="text-meta">{{ item.name }}</v-list-item-title>
                                </v-list-item>
                            </template>
                            <v-list-item v-for="inner in item.children" :value="`/kb/categories/${inner.id}`">
                                <v-list-item-title class="text-meta">{{ inner.name }}</v-list-item-title>
                            </v-list-item>
                        </v-list-group>
                    </template>
                </v-list>
                <p v-else class="text-meta font-weight-medium text-grey-darken-2 user-select-none text-center mt-3">موردی پیدانشد!</p>
            </div>
            <div class="px-2 py-4 w-100">
                <div class="d-flex justify-center ga-3">
                    <a target="_blank" href="https://helpical.com">
                        <v-img src="@/assets/img/helpical-kb-sidebar-logo.svg" class="mx-auto" width="36"></v-img>
                    </a>
                    <div>
                        <a target="_blank" href="https://helpical.com" class="d-block text-small font-weight-medium text-grey-darken-2 text-decoration-none">نرم‌افزار هلپ دسک و تیکتینگ هلپیکال</a>
                        <a target="_blank" href="https://helpical.com/changelog" class="d-block text-small mt-1 text-grey-darken-2 text-decoration-none">نسخه {{ $system.systemSettings.version }}</a>
                    </div>
                </div>
                <div class="mt-3 text-center">
                    <span class="rounded py-1 text-small user-select-none font-weight-medium text-white px-5" :style="`background-color: ${$system.systemSettings.knowledge_base_color}`">{{ $moment(new Date).format('dddd jD jMMMM jYYYY') }}</span>
                </div>
            </div>
        </div>
    </v-navigation-drawer>
    <v-app-bar color="#fff" class="px-4" height="80" :style="{ 'border-bottom': `2px solid ${$system.systemSettings.knowledge_base_color}` }">
        <v-btn @click.stop="drawer = !drawer" class="d-block d-lg-none mx-2" color="grey-darken-1" variant="text" icon="menu"></v-btn>
        <v-text-field
            :loading="searchLoading"
            @keyup.enter="search"
            v-model="searchText"
            hide-details
            variant="solo"
            bg-color="grey-lighten-3"
            class="d-sm-block d-none"
            prepend-inner-icon="search"
            label="جستجو ..."
            style="max-width: 700px;"
        ></v-text-field>
        <v-menu :close-on-content-click="false" location="bottom" z-index="999" v-model="sidebarSearch">
            <template v-slot:activator="{ props }">
                <v-btn v-bind="props" @click="sidebarSearch = true" class="d-block d-sm-none" color="grey-darken-1" variant="text" icon="search"></v-btn>
            </template>
            <v-text-field
                :loading="searchLoading"
                @keyup.enter="search"
                v-model="searchText"
                hide-details
                variant="solo"
                bg-color="grey-lighten-3"
                prepend-inner-icon="search"
                label="جستجو ..."
                style="max-width: 300px;"
            ></v-text-field>
        </v-menu>
        <v-spacer></v-spacer>
        <v-btn :color="$system.systemSettings.knowledge_base_color" variant="flat" class="text-white mx-1" @click="$router.push({ path: '/' })">
            <v-icon size="17" class="me-2" color="#fff">icon-ticketkb</v-icon>سامانه تیکتینگ
        </v-btn>
    </v-app-bar>
    <v-main>
        <v-fade-transition>
            <div class="pa-4 w-lg-75 mx-auto mt-5">
                <slot :key="$route.path" />
            </div>
        </v-fade-transition>
    </v-main>
    <v-dialog v-model="searchDialog" max-width="650" persistent>
        <v-card tile max-height="70vh" min-height="60vh">
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary">نتایج جستجو</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="searchDialog = false">
                    <v-icon size="23" color="primary">close</v-icon>
                </v-btn>
            </v-toolbar>
            <div class="px-6 pt-3">
                <div class="d-flex align-center mb-3 pa-4 border cursor-pointer rounded" v-for="item in searchList" @click="$router.push({ path: `/kb/articles/${item.id}/${item.slug}` }); searchDialog = false;">
                    <v-icon size="21" class="me-2" color="grey-darken-1">icon-filekb</v-icon>
                    <p class="text-meta text-grey-darken-3 flex-grow-1">{{ item.name }}</p>
                    <v-divider class="mx-2 border-opacity-50" vertical></v-divider>
                    <v-icon v-if="item.read_time" class="me-2" color="grey-darken-1" size="16">icon-timekb</v-icon>
                    <p v-if="item.read_time" class="text-small text-grey-darken-2">{{ item.read_time }} دقیقه</p>
                </div>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    auth: false,
    data() {
        return {
            sidebarSearch: false,
            drawer: false,
            selectedMenu: [],
            openedMenu: [],
            searchText: null,
            searchList: [],
            searchLoading: false,
            searchDialog: false,
        }
    },
    methods: {
        async search() {
            this.searchLoading = true;
            this.searchList = [];
            await this.$kbArticleList({ s: this.searchText }).then(res => {
                if (res && res.status == "OK") {
                    if (res.data.length) {
                        this.searchList = [...res.data];
                        this.searchText = null;
                        this.searchDialog = true;
                    }
                    else
                        this.$toast.error('نتیجه ای برای جستجوی شما پیدا نشد.')
                }
            }).finally(() => {
                this.searchLoading = false;
                this.sidebarSearch = false;
            })
        },
        setMetaTitles() {
            this.$headTag.add('link[id="helpical-editor"]', 'link', { id: 'helpical-editor', rel: 'stylesheet', href: '/editor.css' });
            this.$headTag.add('link[id="helpical-prism-css"]', 'link', { id: 'helpical-prism-css', rel: 'stylesheet', href: '/prism.css' });
            this.$headTag.add('script[id="helpical-prism-js"]', 'script', { id: 'helpical-prism-js', async: true, defer: true, src: '/prism.js' });
        },
        resetMetaTitles() {
            this.$headTag.remove('link[id="helpical-editor"]');
            this.$headTag.remove('link[id="helpical-prism-css"]');
            this.$headTag.remove('script[id="helpical-prism-js"]');
        }
    },
    watch: {
        $route() {
            if (this.$route.query.search) {
                this.searchText = this.$route.query.search;
                this.search();
                this.$router.replace({ query: {} });
            }
        },
    },
    async created() {
        this.setMetaTitles();
        if (this.$route.query.search)
            this.$router.replace({ query: {} })
        this.$system.setKbCategories();
        this.openedMenu = [this.$system.kbCategories.filter(x => x.children.some(y => y.to === this.$route.path)).at(-1)?.name ?? null];
        this.selectedMenu = [this.$route.path];
    },
    unmounted() {
        this.resetMetaTitles();
    }
}
</script>
